<div class="c-tournamentReward">
  <div
    class="e-tournamentReward__background"
    theming
    themingGroup="tournament"
    themingAsset="background"
    [themingOverride]="tournamentRewardModalData.properties?.assets">
    @if (tournamentRewardModalData.properties.position <= PODIUM) {
      <div
        class="e-tournamentReward__background__confeti"
        theming
        themingGroup="tournament"
        themingAsset="confeti"
        [themingOverride]="tournamentRewardModalData.properties?.assets"></div>
    }
    <div
      class="e-tournamentReward__logo"
      theming
      themingGroup="tournament"
      themingAsset="logo"
      [themingOverride]="tournamentRewardModalData.properties?.assets"></div>

    <div class="e-tournamentReward__container">
      <span class="title">{{ 'home.live-ops.tournaments.modal-reward.title' | translate | uppercase }}</span>

      <div class="position">
        <div
          class="spark"
          theming
          themingGroup="tournament"
          [themingAsset]="'spark-' + positionText"
          [themingOverride]="tournamentRewardModalData.properties?.assets">
          <div
            class="medal"
            theming
            themingGroup="tournament"
            [themingAsset]="'rank-' + positionText"
            [themingOverride]="tournamentRewardModalData.properties?.assets">
            @if (tournamentRewardModalData.properties.position > PODIUM) {
              <span>{{ tournamentRewardModalData.properties.position }}</span>
            }
          </div>
        </div>
      </div>

      <span class="nickname">{{ user.nickName }}</span>

      @if (!tournamentRewardModalData.reward.credits && !tournamentRewardModalData.reward.gems) {
        <span class="sub-title">{{
          'home.live-ops.tournaments.modal-reward.subtitle'
            | translate: { x: tournamentRewardModalData.properties.lastRewardedPosition }
        }}</span>
      } @else {
        <span class="your-rewards">{{ 'home.live-ops.tournaments.modal-reward.rewards' | translate | uppercase }}</span>

        <div class="e-rewards">
          @for (prize of tournamentRewardModalData.reward | keyvalue; track prize) {
            @if (prize.value) {
              <slotcom-reward-box
                boxThemingGroup="tournament"
                iconThemingGroup="none"
                boxAsset="reward-inactive"
                [iconAsset]="prize.key | lowercase"
                [themingOverride]="tournamentRewardModalData.properties?.assets"
                [numberValue]="prize.value">
              </slotcom-reward-box>
            }
          }
        </div>
      }
    </div>

    <slotcom-button
      class="c-button--pink"
      audioType="reward"
      (safeClick)="closeModal()">
      {{ buttonText | translate | uppercase }}
    </slotcom-button>
  </div>
</div>
